import { getRequest, postRequest } from 'config/Axios/baseConfig';
import { supplierForecastResponseData } from 'Interfaces/FDPInterfaces/supplierForecast';
import axios from 'axios';
import { getCookie } from 'config/Axios/AxiosInstanceConfigs';
import { tokenTypes } from 'utils/AuthUtils/tokenUtils';

let apiBaseUrl;
if (import.meta.env.VITE_MODE == 'dev') {
  apiBaseUrl = import.meta.env.VITE_BACKEND_ENDPOINT;
} else {
  apiBaseUrl = window.config.apiBaseUrl;
}

export const supplierForecastService = {
  getSupplierForecasts: (planning_period: string): Promise<supplierForecastResponseData> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<supplierForecastResponseData>(
          `fdp/get_supplier_forecast/${planning_period}`
        );
        resolve(data);
      } catch (error) {
        console.log('in supplierforecast > getSupplierForecasts => ', error);
        reject(error);
      }
    });
  },

  generateSupplierForecast: (payload: {
    planning_period: string;
  }): Promise<{ success: boolean }> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await postRequest<{ success: boolean }>(
          `fdp/generate_supplier_forecast`,
          payload
        );
        resolve(data);
      } catch (error) {
        console.log('in supplierforecast > generateSupplierForecast => ', error);
        reject(error);
      }
    });
  },

  downloadSupplierForecastExcelFile: (payload: {
    planning_period: string;
    supplier_name: string;
  }): Promise<{ success: boolean }> => {
    return new Promise(async (resolve, reject) => {
      const token = localStorage.getItem(tokenTypes.access) || '';
      const csrfToken = getCookie('csrftoken');

      const apiUrl = `${apiBaseUrl}/fdp/export-particular-supplier-forecast`; // Replace with your actual API endpoint
      try {
        // Step 1: Make the API call
        const response = await axios({
          url: apiUrl,
          method: 'POST',
          responseType: 'blob',
          data: payload, // Treat the response as binary data
          headers: {
            'X-CSRFToken': csrfToken, // Function to retrieve the CSRF token
            Authorization: `Bearer ${token}`, // Function to retrieve the Bearer token
          },
          withCredentials: true,
        });

        // Step 2: Create a Blob from the response data
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });

        // Step 3: Create a link element
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `Supplier Forecast - ${payload.supplier_name}.xlsx`; // Name of the file to download

        // Step 4: Append the link to the DOM, trigger click, and remove it
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        resolve({ success: true });
      } catch (error) {
        // Handle errors
        reject(error);
        console.error('Error downloading the file:', error);
      }

      // export default downloadExcelFile;
    });
  },

  downloadAllSupplierForecastExcelFile: (payload: {
    planning_period: string;
  }): Promise<{ success: boolean }> => {
    return new Promise(async (resolve, reject) => {
      const token = localStorage.getItem(tokenTypes.access) || '';
      const csrfToken = getCookie('csrftoken');

      const apiURL = `${apiBaseUrl}/fdp/export-all-supplier-forecast`;
      try {
        // Making the api call
        const response = await axios({
          url: apiURL,
          method: 'POST',
          responseType: 'blob',
          data: payload,
          headers: {
            'X-CSRFToken': csrfToken,
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        });

        // Creating a blob using the response data
        const blobData = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });

        // Creating a link element for download
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blobData);
        link.download = `Supplier Forecast - ${payload.planning_period}.xlsx`; // providing the name of the excel file

        // appending the ink element to the DOM tree, trigger click and then removing it from the DOM tree
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        resolve({ success: true });
      } catch (error) {
        reject(error);
      }
    });
  },
};
